import React from 'react';

class ImageZoom extends React.Component {
    handleZoomBoxOutsideClick = (e) => {
        e.stopPropagation();
        this.props.updateState({imageZoom:null});
    }

    render() {
        let e,
            top = 0;
        if(this.props.state.imageZoom && this.props.state.imageZoom.e) {
            e = this.props.state.imageZoom.e;
            top = e.target.offsetTop+"px";
            document.addEventListener('click', this.handleZoomBoxOutsideClick, true);
        } else {
            document.removeEventListener('click', this.handleZoomBoxOutsideClick, true);
        }
        return (
            <div
                className={"image-zoom"+(this.props.state.imageZoom ? " image-zoom--open" : "")}
                style={{top:top}}>
                <button
                    className="image-zoom__close"
                    onClick={() => {this.props.updateState({imageZoom:null})}} title="Sulje kuva"></button>
                {this.props.state.imageZoom && this.props.state.imageZoom.img ?
                    <div className="image-zoom__img"><img src={this.props.state.imageZoom.img} alt="Ominaisuudet" /></div>
                    : null
                }
            </div>
        );
    }
}

export default ImageZoom;
